import React from "react"
import { Icon } from "frontend/components/icons"
import styles from "./Button.module.css"
import { handleClickViaKeyboard } from "frontend/utils/a11y"

const Button = (props) => {
  const { label, onClick, disabled, type, className, icon, testId } = props
  const isPrimary = type === "primary"
  const isSecondary = !isPrimary && type === "secondary"
  return (
    <button
      className={`${styles.button} ${isPrimary ? styles.primary : ""} ${
        isSecondary ? styles.secondary : ""
      } ${className}`}
      data-testid={testId || "button"}
      onClick={onClick}
      onKeyPress={handleClickViaKeyboard(onClick)}
      disabled={disabled}
    >
      {icon && <Icon name={icon} isSelectable={false} />}
      {label}
    </button>
  )
}

Button.defaultProps = {
  onClick: () => {},
  disabled: false,
  type: "primary",
}

export default Button
